// extracted by mini-css-extract-plugin
export default {"actionCell":"DatasetOriginColumn-module__actionCell___RBted"};